import MaintenanceBlocker from "@Components/app/notifications/MaintenanceBlocker";
import { AppContext } from "@Context/common/general/context";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useNotificationActions } from "../shared/use-notification-actions";
import { usePlatformNotificationState } from "../shared/use-platform-notification-state";
import { useNotificationCandidate } from "../use-notification-candidate";

const id = "MAINTENANCE_BLOCKER";

const MaintenanceBlockerNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const { handleExit } = useNotificationActions();
  const { isMaintenanceMode } = usePlatformNotificationState();

  const render = useCallback(
    () => <MaintenanceBlocker open={isMaintenanceMode} onExit={handleExit} isUnityEmbedded={state.device.isUnityEmbedded} isSuperAdmin={state.user.isSuperAdmin} />,
    [handleExit, isMaintenanceMode, state.device.isUnityEmbedded, state.user.isSuperAdmin]
  );

  useNotificationCandidate({
    id,
    priority,
    isActive: isMaintenanceMode,
    render,
  });

  return null;
};

export const maintenanceBlockerNotification = defineNotificationModule({
  id,
  Resolver: MaintenanceBlockerNotificationResolver,
});
